import { useContext } from 'react';
import { AlteracaoDePrecoPorItemContextData } from '../types/context';
import { AlteracaoDePrecoPorItemContext } from '../contexts/AlteracaoDePrecoPorItemContext';

export const useAlteracaoDePrecoPorItem =
  (): AlteracaoDePrecoPorItemContextData =>
    useContext(AlteracaoDePrecoPorItemContext);
